/**
 * IconManifest.js
 *
 * Canonical semantic icon manifest for TMS.
 *
 * IMPORTANT:
 * - Values are canonical icon tokens (no vendor prefix, no CSS classes).
 * - Keep keys semantic (what the icon means), not visual.
 * - Rendering/vendor class details are handled by IconsConfig.js (adapter/facade).
 */
(function (global) {
	'use strict';

	var manifest = {
		confirmYes: 'check',
		confirmCancel: 'close',
		actionSave: 'save',
		actionClose: 'close',
		actionEdit: 'edit',
		actionDelete: 'trash',
		actionAdd: 'add',
		statusInfo: 'info',
		statusWarning: 'warning',
		statusError: 'error',
		statusSuccess: 'success',
		navNext: 'next',
		navPrev: 'prev',
		actionRefresh: 'refresh',
		fallback: 'help'
	};

	// Allow pre-definition/override while keeping sane defaults.
	if (!global.TMS_ICON_MANIFEST) {
		global.TMS_ICON_MANIFEST = manifest;
		return;
	}

	/**
	 * Merges missing semantic keys into an existing manifest override.
	 *
	 * @param {string} key semantic key to merge
	 */
	Object.keys(manifest).forEach(function (key) {
		if (!Object.prototype.hasOwnProperty.call(global.TMS_ICON_MANIFEST, key)) {
			global.TMS_ICON_MANIFEST[key] = manifest[key];
		}
	});
})(typeof window !== 'undefined' ? window : this);
